import React, { useState, useEffect } from "react";
import { FaGlobe, FaMicrochip, FaShieldAlt, FaHandPointUp, FaFileAlt, FaBolt, FaChartLine, FaStar } from "react-icons/fa";

import { About } from "./about";
import { Services } from "./services";
import { Features } from "./features";
import { Team } from "./Team";
import { Gallery } from "./gallery";
import { WhyChooseUs} from "./WhyChooseUs";

import JsonData from "../data/data.json";
import SmoothScroll from "smooth-scroll";
import "../App.css";
import { Slidershow } from "./slidershow";
import { LdServices } from "./ldserv";

export const scroll = new SmoothScroll('a[href*="#"]', {
  speed: 1000,
  speedAsDuration: true,
});

const Landing = () => {
  const [landingPageData, setLandingPageData] = useState({});
  useEffect(() => {
    setLandingPageData(JsonData);
  }, []);

   const items = [
    { icon: <FaGlobe />, label: "Digital" },
    { icon: <FaMicrochip />, label: "Tecnológico" },
    { icon: <FaShieldAlt />, label: "Seguro" },
    { icon: <FaHandPointUp />, label: "Prático" },
    { icon: <FaFileAlt />, label: "Acessível" },
    { icon: <FaBolt />, label: "Disruptivo" },
    { icon: <FaChartLine />, label: "Moderno" },
    { icon: <FaStar />, label: "Exclusivo" },
  ];

  return (
    <div>
      <Slidershow />
      <About data={landingPageData.About} />
      <WhyChooseUs 
        title="PORQUE NOS ESCOLHER? POR QUE SOMOS!" 
        items={items} 
      />
      <LdServices data={landingPageData.Services} />
      <Services data={landingPageData.Services2} />
      <Features data={landingPageData.Features} />
      <Team data={landingPageData.Team} />
      <Gallery data={landingPageData.Gallery} />
    </div>
  );
};

export default Landing;
